import styled from "styled-components";
import { default as SlickSlider } from "@ant-design/react-slick";
import { layout, LayoutProps, SpaceProps, space } from "styled-system";
import { variant } from "styled-system";

import { sliderVariants } from "./variants";
import React from "react";

const Slider = styled(SlickSlider)<
  LayoutProps &
    SpaceProps & {
      variant?: "full-width" | "dots";
      children: React.ReactNode
    }
>`
  position: relative;
  .slick-track {
    display: flex;
  }
  .slick-list {
    position: relative;
    z-index: 2;
  }
  .slick-slide {
    & > div {
      height: 100%;
      & > div {
        outline: none;
        height: 100%;
        display: flex !important;
        position: relative;
      }
    }
  }
  ${(props) => {
    const themedVariants = sliderVariants(props.theme);
    return variant({ variants: themedVariants });
  }}
  ${layout}
  ${space}
`;

export default Slider;
